<template>
  <div class="grey4">
    <v-container class="py-10">
      <!-- Headline -->
      <div style="text-align: center">
        <h1 :class="{ title: $vuetify.breakpoint.smAndDown }">So einfach funktioniert TRADANA</h1>
        <p :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '14px' : '' }">In wenigen Schritten Traueranzeigen<br class="hidden-sm-and-up"> erstellen & veröffentlichen</p>
      </div>

      <!-- Steps -->
      <v-row style="max-width: 1200px; margin: 45px auto 20px">
        <v-col cols="6" sm="4" v-for="(step, i) in steps" :key="i" style="margin-bottom: 30px">
          <p style="text-align: center; white-space: pre-wrap" class="font-weight-medium" :class="{ title: $vuetify.breakpoint.mdAndUp }" :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '16px' : '' }">
            {{ $vuetify.breakpoint.smAndDown ? step.title.replace('-', '-\n').replace(' ', '\n') : step.title }}
          </p>

          <div style="text-align: center" class="mb-4">
            <v-icon style="text-align: center; height: 60px" :size="step.icon === 'media' && $vuetify.breakpoint.mdAndUp ? 150 : step.icon !== 'media' && $vuetify.breakpoint.mdAndUp ? 60 : step.icon === 'media' && $vuetify.breakpoint.smAndDown ? 90 : 40">
              ${{ step.icon }}
            </v-icon>
          </div>

          <div style="clear: both; max-width: 300px; margin: auto">
            <div class="d-flex">
              <div style="color: var(--v-grey-base);" :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '30px' : '60px' }" class="mr-4">
                {{i + 1}}
              </div>
              <div style="padding-top: 6px" :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '10px' : '' }">
                <p>
                  {{ step.text }}
                </p>
              </div>
            </div>
          </div>

        </v-col>
      </v-row>

      <!-- Mail Entry -->
      <div style="max-width: 1200px; margin: auto">
        <v-container class="px-0">
          <h2>
            Sparen Sie viel Zeit und Aufwand! Probieren Sie TRADANA jetzt aus.
          </h2>
        </v-container>
        <tradana-mail-entry position="1"></tradana-mail-entry>
      </div>
    </v-container>
  </div>
</template>

<script>
import MailEntry from '@/components/global/MailEntry.vue'
export default {
  data () {
    return {
      steps: [
        {
          title: 'Anzeigen-Gestaltung',
          icon: 'create',
          text: 'Dank intuitivem Editor und zahlreicher Vorlagen in wenigen Minuten zur fertigen Anzeige.'
        },
        {
          title: 'Echtzeit-Preisermittlung',
          icon: 'pricetag',
          text: 'Der Preis zur Veröffentlichung in gewünschten Zeitungen passt sich an Größe und Farbwünsche an.'
        },
        {
          title: 'Direkte Kundenrückmeldung',
          icon: 'feedback',
          text: 'Der Kunde kann direkt mit Ihnen zusammen oder selbst zuhause Änderungen vornehmen.'
        },
        {
          title: 'Automatische Weiterleitung',
          icon: 'forward',
          text: 'Die fertige Anzeige wird dem Verlag übermittelt und wir kümmern uns um alles weitere.'
        },
        {
          title: 'Einfache Abrechnung',
          icon: 'invoice',
          text: 'Sie sehen den Status aller Anzeigen und werden bei Auftragsbestätigung informiert.'
        },
        {
          title: 'Schnelle Veröffentlichung',
          icon: 'media',
          text: 'Die Anzeige wird in der Zeitung, auf Ihrer Webseite und als Gedenkseite veröffentlicht.'
        }
      ]
    }
  },
  components: {
    TradanaMailEntry: MailEntry
  }
}
</script>
